import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { useGetRecoveryFundsByFundraisingId } from '@/query/queries/loan/useGetRecoveryFundsByFundraisingId';
import s from './index.module.scss';

export const FundsRecovery = ({ fundraisingID }) => {
  const { t } = useTranslation('loans');
  const { data: fundsInRecoveryByFundraisingID } =
    useGetRecoveryFundsByFundraisingId(fundraisingID);

  const funds = fundsInRecoveryByFundraisingID || [];

  if (!funds.length) {
    return null;
  }

  return (
    <div className={s.wrapper}>
      <h2 className="f-article-accent">{t('loan_info.funds_in_recovery')}</h2>
      <div className={s.table}>
        <div className={classnames(s.thead)}>
          <div className={s.thead_col}>{t('loan_info.company_name')}</div>
          <div className={s.thead_col}>{t('loan_info.loan_amount')}</div>
          <div className={s.thead_col}>{t('loan_info.outstanding')}</div>
          <div className={s.thead_col}>{t('loan_info.in_recovery')}</div>
        </div>
        <div className={s.tbody}>
          {funds.map((loan, idx) => (
            <div className={classnames(s.tbody_row)} key={idx}>
              <div className={s.tbody_col}>{loan.company_name}</div>
              <div className={s.tbody_col}>
                {prettyFloatMoney(loan.total_loan_amount)}
              </div>
              <div className={s.tbody_col}>
                {prettyFloatMoney(loan.total_repaid_amount)}
              </div>
              <div className={s.tbody_col}>
                {prettyFloatMoney(loan.fund_in_recovery)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
